import { motion } from 'framer-motion';
import { ShieldCheck, Award, Scale, Lock, FileCheck, GraduationCap, ExternalLink } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { useT } from '@/lib/i18n';

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

export function ConsultingTrustSignals() {
  const t = useT();
  const trustItems = [
    { icon: Lock, label: t('DSGVO konform', 'GDPR compliant') },
    { icon: ShieldCheck, label: 'NIS2 ready' },
    { icon: Scale, label: 'DORA compliant' },
    { icon: FileCheck, label: 'EU AI Act' },
    { icon: Award, label: 'ISO 42001' },
    { icon: GraduationCap, label: t('IHK geprüft', 'IHK certified') },
  ];
  return (
    <section className="py-12 md:py-16" aria-label={t('Compliance und Zertifizierungen', 'Compliance and certifications')}>
      <div className="container mx-auto px-6">
        <motion.div className="text-center mb-8" {...fadeUp} transition={{ duration: 0.5 }}>
          <h2 className="text-xl md:text-2xl font-bold">
            {t('Compliance & ', 'Compliance & ')}<span className="text-primary">{t('Vertrauen', 'trust')}</span>
          </h2>
          <p className="mt-2 text-sm text-muted-foreground">
            {t('Regulatorische Sicherheit für Ihre digitale Transformation', 'Regulatory safety for your digital transformation')}
          </p>
        </motion.div>
        <motion.div
          className="flex flex-wrap justify-center gap-3 md:gap-4"
          {...fadeUp}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          {trustItems.map((item) => (
            <Badge
              key={item.label}
              variant="outline"
              className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-primary/20 bg-primary/5 hover:bg-primary/10 transition-colors"
            >
              <item.icon className="w-4 h-4 text-primary" aria-hidden="true" />
              {item.label}
            </Badge>
          ))}
        </motion.div>
        <motion.p
          className="mt-6 text-center text-xs sm:text-sm text-muted-foreground"
          {...fadeUp}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {t(
            'Formale Audits nach ISO/IEC 42001 und ISO/IEC 27001 führen wir über unsere Schwestermarke ',
            'Formal audits to ISO/IEC 42001 and ISO/IEC 27001 are delivered through our sister brand ',
          )}
          <a
            href="https://www.der-ki-auditor.de"
            target="_blank"
            rel="noopener noreferrer external"
            className="inline-flex items-center gap-1 font-mono font-semibold text-primary hover:underline underline-offset-4"
          >
            DER-KI-AUDITOR
            <ExternalLink className="w-3 h-3" aria-hidden="true" />
          </a>
          .
        </motion.p>
      </div>
    </section>
  );
}
